exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n/* Component used through ContentTool */\n\n.pick__picker-button--3Eb3I {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: transparent; /* external style [CT] */\n\tborder: 0; /* external style [CT] */\n\tbox-sizing: border-box; /* external style [CT] */\n\tcursor: pointer; /* external style [CT] */\n\tmargin: 0;\n\tpadding: 0;\n}\n", ""]);

// exports
exports.locals = {
	"picker-button": "pick__picker-button--3Eb3I"
};